var generateStyle = function generateStyle(componentTheme) {
  return {
    sidebarItemWrapper: {
      transform: 'translate3d(0, 0, 0)' /* for drag and drop preview to work */
    }
  };
};
export default generateStyle;